<template>
  <div class="newsDetail" v-if="isLoading">
    <div class="addExperiment-title">
      <span @click="goRouter('/news')"
        >消息中心&nbsp;&nbsp; / &nbsp;&nbsp;</span
      >
      <i>消息详情</i>
    </div>
    <div class="container">
      <div class="content">
        <div class="news-detail-title">
          <h3>{{ newsDetailObj.title }}</h3>
          <p>
            {{ getTime(newsDetailObj.sendDate) }} {{ newsDetailObj.sendName }}
          </p>
        </div>
        <div class="news-detail-content">
          <div v-html="newsDetailObj.msgContent"></div>
        </div>
      </div>
    </div>
    <div class="goBack" @click="goRouter('/news')">
      <el-button type="primary">返回</el-button>
    </div>
  </div>
</template>

<script>
import util from "@/assets/util/util.js";
export default {
  name: "VirtualimitationNewsdetail",

  data() {
    return {
      newsDetailObj: {},
      isLoading: false,
    };
  },

  mounted() {
    this.getDetail();
  },

  methods: {
    //获得详情信息
    getDetail() {
      this.$api.news.getMsgDetail(this.$route.query.id).then((res) => {
        if (res.data != null && res.errCode == 0) {
          this.newsDetailObj = res.data;
          this.isLoading = true;
        }
      });
    },
    goRouter(path) {
      this.$router.push(path);
    },
    getTime(date) {
      return util.getTime(date);
    },
  },
};
</script>

<style lang="less" scoped>
.newsDetail {
  width: 100%;
  position: relative;
  flex: 1;
  .goBack {
    position: absolute;
    top: 50px;
    right: 20px;
  }
  .container {
    width: 100%;
    height: calc(100% - 40px);
    background: #fff;
    .content {
      width: 1051px;
      margin: 0 auto;
      .news-detail-title {
        padding: 29px 0 19px 0;
        border-bottom: 1px solid #eef2fa;
        h3 {
          text-align: center;
          font-size: 18px;
          font-family: PingFang-SC;
          font-weight: 500;
          line-height: 25px;
          color: #101012;
          opacity: 1;
          margin-bottom: 12px;
        }
        p {
          text-align: center;
          font-size: 12px;
          font-family: PingFang-SC;
          font-weight: 400;
          line-height: 17px;
          color: #7e7e7e;
          opacity: 1;
        }
      }
      .news-detail-content {
        padding: 32px 0;
        font-size: 14px;
        font-family: PingFang-SC;
        font-weight: 400;
        line-height: 20px;
        color: #424346;
        opacity: 1;
      }
    }
  }
  .addExperiment-title {
    margin-bottom: 16px;
    span,
    i {
      font-size: 14px;
      font-family: PingFang-SC;
      font-weight: 400;
      line-height: 20px;
      color: #424346;
      opacity: 1;
      font-style: normal;
    }
    span {
      color: #939393;
      cursor: pointer;
    }
  }
}
</style>